export enum Plan {
  FREE = 'free',
  PRO = 'pro',
  TEAM = 'team',
}

export enum Feature {
  // Free features
  BASIC_RECORDING = 'BASIC_RECORDING',
  LIVE_VIEWER = 'LIVE_VIEWER',
  SESSION_REPLAY = 'SESSION_REPLAY',
  SESSION_EXPORT = 'SESSION_EXPORT',
  SESSION_COMPARE = 'SESSION_COMPARE',
  // Paid features
  CLOUD_SYNC = 'CLOUD_SYNC',
  API_ACCESS = 'API_ACCESS',
  EXTENDED_RETENTION = 'EXTENDED_RETENTION',
  TEAM_SHARING = 'TEAM_SHARING',
  PRIORITY_SUPPORT = 'PRIORITY_SUPPORT',
}

const FREE_FEATURES = new Set<Feature>([
  Feature.BASIC_RECORDING,
  Feature.LIVE_VIEWER,
  Feature.SESSION_REPLAY,
  Feature.SESSION_EXPORT,
  Feature.SESSION_COMPARE,
]);

const PRO_FEATURES = new Set<Feature>([
  ...FREE_FEATURES,
  Feature.CLOUD_SYNC,
  Feature.API_ACCESS,
  Feature.EXTENDED_RETENTION,
  Feature.PRIORITY_SUPPORT,
]);

const TEAM_FEATURES = new Set<Feature>([
  ...PRO_FEATURES,
  Feature.TEAM_SHARING,
]);

const PLAN_FEATURES: Record<Plan, Set<Feature>> = {
  [Plan.FREE]: FREE_FEATURES,
  [Plan.PRO]: PRO_FEATURES,
  [Plan.TEAM]: TEAM_FEATURES,
};

export interface PlanLimits {
  maxSessions: number;
  maxAgeDays: number;
  maxFramesPerSession: number;
}

/** -1 means unlimited */
const PLAN_LIMITS: Record<Plan, PlanLimits> = {
  [Plan.FREE]: { maxSessions: 100, maxAgeDays: 30, maxFramesPerSession: 500 },
  [Plan.PRO]: { maxSessions: -1, maxAgeDays: 365, maxFramesPerSession: -1 },
  [Plan.TEAM]: { maxSessions: -1, maxAgeDays: 365, maxFramesPerSession: -1 },
};

export function hasFeature(plan: Plan, feature: Feature): boolean {
  return PLAN_FEATURES[plan].has(feature);
}

export function getPlanLimits(plan: Plan): PlanLimits {
  return { ...PLAN_LIMITS[plan] };
}
